import { ColumnDef } from '@tanstack/react-table';

export interface IPaperlessRes {
  id: number;
  oldStatus: 'Electronic' | 'Paper';
  newStatus: 'Electronic' | 'Paper';
  modifiedDate: string; // '21 Mar 2023'
  modifiedBy: string;
}

export const paperlessCol: ColumnDef<IPaperlessRes>[] = [
  {
    enableSorting: true,
    accessorKey: 'oldStatus',
    header: 'Old Status',
  },
  {
    enableSorting: true,
    accessorKey: 'newStatus',
    header: 'New Status',
  },
  {
    enableSorting: true,
    accessorKey: 'modifiedDate',
    header: 'Modified Date',
    cell: ({ row }) => (
      <div className="flex gap-[5px]">
        <div>{row.getValue('modifiedDate')}</div>
        <div className="text-[14px] text-addition1-50">21:53 PDT</div>
      </div>
    ),
  },
  {
    enableSorting: true,
    accessorKey: 'modifiedBy',
    header: 'Modified By',
  },
];

const data: IPaperlessRes = {
  id: 2,
  oldStatus: 'Paper',
  newStatus: 'Electronic',
  modifiedDate: '21 Mar 2023',
  modifiedBy: 'Msm_Super',
};

export const paperlessData: IPaperlessRes[] = [
  {
    id: 0,
    oldStatus: 'Electronic',
    newStatus: 'Paper',
    modifiedDate: '21 Mar 2023',
    modifiedBy: 'info_Justins',
  },
];

for (let i = 0; i < 30; i++) {
  paperlessData.push({ ...data, id: i + 1 });
}
